import t from '~/scopes/campaign/data/metals/hafnium.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['scrreenHafnium2025'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['scrreenHafnium2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['scrreenHafnium2025'],
  },
  // Every environmental sub-section reads `n/a`, so the summary stands alone; on the
  // human side only displacement and legal are filled.
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['pblEnvironmental2024', 'scrreenHafnium2025'],
      },
      blocks: [],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['pblSocial2025', 'scrreenHafnium2025'],
      },
      blocks: [
        {
          title: SECTIONS.humanDisplacement,
          text: t.humanDisplacementText,
          sourceRefs: ['scrreenHafnium2025'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: ['scrreenHafnium2025'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['scrreenHafnium2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['scrreenHafnium2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['scrreenHafnium2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['scrreenHafnium2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['scrreenHafnium2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['scrreenHafnium2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ieaMineralsExplorer', 'scrreenHafnium2025'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['scrreenHafnium2025', 'matosMsa2021'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['scrreenHafnium2025', 'matosMsa2021'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['scrreenHafnium2025', 'matosMsa2021'],
      },
    ],
  },
  // `*` on the four scores it names; `**` on the countries heading it explains.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
          sourceRefs: ['ademe2024'],
        },
      ],
      slots: [
        'environmentalScore',
        'humanScore',
        'geopoliticalScore',
        'supplyRiskScore',
      ],
    },
    {
      body: [
        {
          text: t.footnote2Text1,
          sourceRefs: ['usgsMcs2025', 'scrreenHafnium2025'],
        },
      ],
      slots: ['countries'],
    },
  ],
} as const
